<template>
  <alzata-dialog
    ref="medicationModal"
    :title="medication?.id ? 'Edit Medication' : 'Create Medication'"
  >
    <div class="row g-2">
      <div class="col-12">
        <label for="name" class="small">Name *</label>
        <input
          id="name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.name }"
          placeholder="Name"
          v-model="name"
        />

        <div v-if="errors.name" class="invalid-feedback">
          Name is required.
        </div>

        <label for="instructions" class="small">Instructions *</label>
        <textarea
          rows="5"
          id="instructions"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.instructions }"
          placeholder="Instructions"
          v-model="instructions"
        ></textarea>
        
        <div v-if="errors.instructions" class="invalid-feedback">
          Instructions are required.
        </div>

        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            id="isActive"
            v-model="isActive"
          />
          <label class="form-check-label" for="isActive">Is Active</label>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="hide">Cancel</button>
      <button type="button" class="btn btn-primary" @click="save">Save</button>
    </template>
  </alzata-dialog>
</template>

<script>
export default {
  name: "EditMedicationDialog",
  emits: ["save"],
  mounted() {},
  data() {
    return {
      medication: null,
      name: null,
      instructions: null,
      isActive: null,
      errors: {
        name: false,
        instructions: false,
      },
    };
  },
  methods: {
    clearValidation() {
      this.errors.name = false;
      this.errors.instructions = false;
    },
    show(medication) {
      this.medication = medication;
      this.name = medication.name;
      this.instructions = medication.instructions;
      this.isActive = medication.isActive;

      this.clearValidation();

      this.$refs.medicationModal.show();
    },
    hide() {
      this.$refs.medicationModal.hide();
    },
    save() {

      this.errors.name = !this.name;
      this.errors.instructions = !this.instructions;

      if (this.errors.name || this.errors.instructions) {
        return;
      }

      this.$emit("save", {
        id: this.medication.id,
        name: this.name,
        instructions: this.instructions,
        isActive: this.isActive,
      });
    },
  },
};
</script>
